export default "__VITE_ASSET__CPG_Qkxq__"